<h5>Welcome to MyKE!</h5>
<h6>Your personalized source for information about your Kenan-Flagler experience</h6>
<br /><br />

<p>Please log in using your <strong>Kenan-Flagler Business Account</strong> credentials.</p>

<button class="btn btn-outline-primary" (click)="auth.redirectToDashboard()">
    <span>Log in now</span>
</button>
<br /><br />
<p>If you are returned to this page multiple times there may be an issue with the username or password entered.   Please contact the <a href="mailto:itservicedesk@kenan-flagler.unc.edu">Kenan-Flagler IT Service Desk</a> for assistance.</p>
